import React, { useEffect, useState } from "react";
import CandidateTab from "../CandidateTab";
import Sidebar from "../Sidebar";
import Header from "../Header";
import Footer from "../Footer";
import { useDispatch, useSelector } from "react-redux";
import ClientHeader from "../Partials/ClientHeader";
import ClientSideBar from "../Partials/ClientSideBar";
import NotificationPanels from "../NotificationPanels";
import IBVerification from "./IBVerification";
import EventCoachFlow from "./EventCoachFlow";
import DocUpload1 from "./DocUpload1";
import ProgressHeading from "../Common/ProgressHeading";

const MainFormPageVisual = () => {
  const [role, setRole] = useState();
  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);
  return (
    <>
      <NotificationPanels />
      {role == "EP" ? <ClientHeader /> : <Header />}
      {role == "EP" ? <ClientSideBar /> : <Sidebar />}
      <section
        className="main-section candidate-tab-form"
        style={{ maddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Visual Document"} />
            </div>
            <div className="col bg-gray-mbl">
              <EventCoachFlow />
              {/* <BankVerification /> */}
              {/* <IBVerification /> */}
            </div>
          </div>
        </div>
      </section>
      <div className="d-flex justify-content-center align-items-center">
        <Footer />
      </div>
    </>
  );
};

export default MainFormPageVisual;
